import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@app/environment';
import { joinUrl } from '@app/shared/utils';

export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const url =
    req.url.startsWith('http') || req.url.startsWith('/assets') ? req.url : joinUrl(environment.apiUrl, req.url);

  return next(
    req.clone({
      url,
      withCredentials: true,
    }),
  );
};
